module.exports = __webpack_public_path__ + "img/00022.acbe23be.webp";